var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.products && _vm.products.length
        ? _c(
            "PimProductTableList",
            {
              staticClass: "pim-product-table-list--products",
              attrs: { headers: _vm.headers },
            },
            _vm._l(_vm.products, function (product, index) {
              return _c(
                "PimProductTableListRow",
                { key: product.pim_id },
                [
                  _c(
                    "PimProductTableListColumn",
                    [
                      _c("GlobalInlineTile", {
                        attrs: {
                          title:
                            "<b>" +
                            product.title +
                            "</b> " +
                            product.titlesuffix,
                          subtitle: product.subtitle,
                          image: product.image_src,
                          "image-link": product.detail_link,
                          "title-link": product.detail_link,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("PimProductTableListColumn", [
                    _c("span", [_vm._v(_vm._s(product.art))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "PimProductTableListColumn",
                    [
                      _vm._t(
                        "actions",
                        function () {
                          return [
                            _vm._v(
                              '\n                    Please override the "actions" slot in your template. The "item" and the "index" are passed as properties.\n                '
                            ),
                          ]
                        },
                        { item: product, index: index }
                      ),
                    ],
                    2
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }